<!--资格码报单-->
<template>
  <div>
    <app-breadcrumb/>
    <div v-loading="doLoading" class="page-container Qualification">
      <el-table
          v-if="isAgent"
          :data="list"
          border
          size="mini"
          fit
          highlight-current-row
          max-height="270px"
          style="width: 100%;margin-bottom: 20px"
      >
        <!--经销商编号-->
        <el-table-column :label="$t('miMember.memberNo')" prop="havedNo" align="center"/>
        <!--资格码-->
        <el-table-column :label="$t('Qualification_code')" prop="qualificationCode" align="center">
          <template slot-scope="scope">
            <span v-if="!scope.row.qOrderNo" @click="copyData(scope.row.qualificationCode)"
                  style="color: #b3640d">{{ scope.row.qualificationCode }}</span>
            <span v-else style="color: #999999">{{ scope.row.qualificationCode }}</span>
          </template>
        </el-table-column>
        <!--订单编号-->
        <el-table-column :label="$t('poOrder.orderNo')" prop="qOrderNo" align="center">
          <template slot-scope="scope">
            {{ scope.row.qOrderNo ? scope.row.qOrderNo : $t('Unused') }}
          </template>
        </el-table-column>
      </el-table>
      <el-form label-width="auto" size="mini">
        <el-row :gutter="20">
          <el-col :md="12" :lg="12" :xl="12">
            <el-form-item size="mini" :label="$t('miMember.memberNo')+':'" class="hong-xing">
              <!--:readonly="memberNoDisabled"-->
              <el-input
                  :class="{ 'disabled_remove_css': memberNoDisabled}"
                  v-model.trim="formData.memberNo"
                  clearable
                  :placeholder="$t('')"
                  @blur="getAgentNo()"
              />
            </el-form-item>
          </el-col>
          <el-col :md="12" :lg="8" :xl="6">
            <p
                :class="{ 'account_name_css': account_name_show}"
                style="color:#538E0D; font-weight:bold; line-height: 4px;">{{ memberNoData.accountName }}
            </p>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :md="12" :lg="12" :xl="12">
            <!--资格码-->
            <el-form-item size="mini" :label="$t('Qualification_code')+':'" class="hong-xing">
              <el-input
                  v-model.trim="formData.qualificationCode"
                  clearable
                  :placeholder="$t('')"
                  @blur="checkQualificationCode()"
              />
            </el-form-item>
          </el-col>
          <el-col :md="12" :lg="8" :xl="6">
            <p
                :class="{ 'account_name_css': qualificationAble}"
                style="font-weight:bold; line-height: 4px;">
            </p>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :md="12" :lg="12" :xl="12">
            <!--支付方式-->
            <el-form-item size="mini" :label="$t('poOrder.payWay')+':'" class="hong-xing">
              <el-radio-group v-model="formData.payType">
                <template v-for="(item, index) in radioList">
                  <div
                      v-if="item.isShow"
                      :key="item.label"
                      :style="{'margin-bottom' : index===(radioList.length-1) ? 0 : '10px'}">
                    <el-radio :label="item.label">{{ item.value }}</el-radio>
                  </div>
                </template>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <div v-if="!isAgent">
          <el-row :gutter="20">
            <el-col :md="12" :lg="12" :xl="12">
              <!--        收货人姓名-->
              <el-form-item
                  size="mini"
                  :label="$t('PoOrder.recName')"
                  class="hong-xing"
              >
                <el-input v-model.trim="formData.name" clearable :placeholder="$t('')"/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :md="12" :lg="12" :xl="12">
              <!--        联系电话-->
              <el-form-item
                  size="mini"
                  :label="$t('sysCompany.phone')"
                  class="hong-xing"
              >
                <el-input v-model.trim="formData.recPhone" clearable :placeholder="$t('')"/>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :md="12" :lg="12" :xl="12">
              <!--        收货地址-->
              <el-form-item :label="$t('ssCustomer.saddress')">
                <el-radio-group class="radio-group" v-model="formData.recType">
                  <el-radio :label="1">
                    {{ this.$t('pick.up.from.franchise') }}:{{ memberNoData.agentNo }} - {{ memberNoData.agentName }}
                  </el-radio>
                  <div style="margin: 10px 0"/>
                  <el-radio :label="2">
                    {{ this.$t('pick.up.from.branch.office') }}
                  </el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <el-row :gutter="20">
          <el-col :md="12" :lg="12" :xl="12">
            <!--         支付密码 -->
            <el-form-item
                size="mini"
                :label="$t('please.input.your.pay.password')"
                class="hong-xing"
            >
              <el-input v-model.trim="formData.payPassword" show-password clearable placeholder=""/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :md="12" :lg="12" :xl="12">
            <el-form-item
                size="mini"
                :label="$t('pdWarehouseStock.productNo')"
            >
              {{ formData.goodsList[0].goodsCode }} x1
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div style="text-align: center; margin-bottom: 10px;margin-top: 10px">
        <!--        提交-->
        <el-button size="mini" :loading="doLoading" type="success" icon="el-icon-check" @click="formSubmit">
          {{ $t('title.submit') }}
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>

import {
  miMemberInfo,
  procQualificationCanUse,
  procQualificationListByAgent,
  procQualificationSaveOrder
} from "@/api/member";
import {mapGetters} from "vuex";

export default {
  name: 'Qualification',
  directives: {},
  components: {},
  data() {
    return {
      companyList: {
        GH: ['5'], //加纳
        CI: ['5'], //科特迪瓦
        ZA: [], //南非
        NG: ['5'], //尼日利亚
        CM: ['5'], //喀麦隆
        CO: ['5'] //刚果（东非）
      },
      radioList: [
        {label: '1', value: '1000EDollar', isShow: false},
        {label: '2', value: '1000F000', isShow: false},
        {label: '3', value: '100$ + 100EDollar', isShow: false},
        {label: '4', value: '100$ + 100F000', isShow: false},
        {label: '5', value: '100$', isShow: false},
      ],
      formData: {
        payPassword: '',
        memberNo: '',
        qualificationCode: '',
        payType: '',
        name: '',
        recPhone: '',
        recType: '',
        storeAddr: '',
        goodsList: [
          {goodsCode: 'M030-00', buyQty: 1}
        ]
      },
      memberNoData: {
        accountName: null
      },
      list: [],
      qualificationAble: false,
      memberNoDisabled: false,
      account_name_show: false,
      doLoading: false,
      total: 0
    }
  },
  computed: {
    ...mapGetters([
      'userCode',
      'companyCode',
      'isAgent'
    ]),
  },
  watch: {},
  beforeCreate() {
  },
  created() {
    this.getAgentNo()
    if (this.isAgent) {
      this.getList()
    }
  },
  beforeMount() {
  },
  mounted() {
    this.initRadioList()
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  activated() {
  },
  methods: {
    initRadioList() {
      let showRadioList = this.companyList[this.companyCode]
      for (let i = 0; i < this.radioList.length; i++) {
        this.radioList[i].isShow = showRadioList.includes(this.radioList[i].label)
      }
    },
    getList() {
      this.doLoading = true
      procQualificationListByAgent().then(res => {
        this.doLoading = false
        this.list = res.data
      }).catch(err => {
        console.error(err)
        this.doLoading = false
      })
    },
    checkQualificationCode() {
      this.doLoading = true
      this.qualificationAble = false
      console.log(this.formData.qualificationCode)
      procQualificationCanUse({
        qualificationCode: this.formData.qualificationCode
      }).then(res => {
        this.doLoading = false
        this.qualificationAble = false
        console.log(res)
      }).catch(err => {
        console.error(err)
        this.doLoading = false
        this.qualificationAble = true
      })
    },
    async getAgentNo() {
      this.memberNoDisabled = !this.isAgent
      this.formData.memberNo = !this.isAgent ? this.userCode : this.formData.memberNo
      if (this.formData.memberNo) {
        try {
          this.doLoading = true
          let res = await miMemberInfo({memberNo: this.formData.memberNo})
          this.memberNoData = res.data
          this.formData.name = this.memberNoData.name
          this.formData.recPhone = this.memberNoData.mobile
          this.formData.storeAddr = this.memberNoData.storeAddr
          this.doLoading = false
          this.account_name_show = false
          console.log(JSON.parse(JSON.stringify(this.memberNoData)))
        } catch (err) {
          console.log(err)
          this.doLoading = false
          this.memberNoData.accountName = ''
          this.account_name_show = true
        }
      }
    },
    formSubmit() {
      console.log(this.formData, 'formData')
      if (!this.formData.memberNo) {
        this.$message.warning(this.$t('label.pleaseFillIn').toString() + ' ' + this.$t('miMember.memberNo').toString())
        return
      }
      if (!this.formData.qualificationCode) {
        this.$message.warning(this.$t('label.pleaseFillIn').toString() + ' ' + this.$t('Qualification_code').toString())
        return
      }
      if (!this.formData.payPassword) {
        this.$message.warning(this.$t('please.input.your.pay.password').toString())
        return
      }
      if (!this.formData.payType) {
        this.$message.warning(this.$t('poOrder.pleaseChoose').toString() + ' ' + this.$t('poOrder.payWay').toString())
        return
      }
      // 促销金额赋值
      // {label: '1', value: '1000EDollar', isShow: true},
      // {label: '2', value: '1000F000', isShow: true},
      // {label: '3', value: '100$ + 100F000', isShow: true},
      // {label: '4', value: '100$ + 100EDollar', isShow: true},
      // totalAmount = 金额
      // totalpointa0 = EDollar
      // totalF0 = F000
      switch (this.formData.payType) {
        case "1":
          this.formData.totalAmount = 0
          this.formData.totalpointa0 = 1000
          this.formData.totalF0 = 0
          break
        case "2":
          this.formData.totalAmount = 0
          this.formData.totalpointa0 = 0
          this.formData.totalF0 = 1000
          break
        case "3":
          this.formData.totalAmount = 100
          this.formData.totalpointa0 = 100
          this.formData.totalF0 = 0
          break
        case "4":
          this.formData.totalAmount = 100
          this.formData.totalpointa0 = 0
          this.formData.totalF0 = 100
          break
        case "5":
          this.formData.totalAmount = 100
          this.formData.totalpointa0 = 0
          this.formData.totalF0 = 0
          break
        default:
          this.formData.totalAmount = 'A'
          this.formData.totalpointa0 = 'A'
          this.formData.totalF0 = 'A'
      }
      if (this.formData.totalAmount === 'A'|| this.formData.totalpointa0 === 'A'||this.formData.totalF0 === 'A') {
        this.$message.warning(this.$t('poOrder.pleaseChoose').toString() + ' ' + this.$t('poOrder.payWay').toString())
        return
      }
      this.doLoading = true
      procQualificationSaveOrder({...this.formData}).then(() => {
        this.doLoading = false
        this.$message.success(this.$t('bdSendRegister.operaterSuccess'))
        this.$router.push({name: 'OrderQuery'})
      }).catch(err => {
        console.error(err)
        this.doLoading = false
      })
    },
    copyData(val) {
      // navigator.clipboard.writeText(val).then(()=>{
      //   this.$message.success('copy success')
      // })
      const textArea = document.createElement('textArea')
      textArea.value = val
      textArea.style.width = 0
      textArea.style.position = 'fixed'
      textArea.style.left = '-999px'
      textArea.style.top = '10px'
      textArea.setAttribute('readonly', 'readonly')
      document.body.appendChild(textArea)
      textArea.select()
      document.execCommand('copy')
      this.$message.success('copy success')
      document.body.removeChild(textArea)
    },
  }
}

</script>

<style lang="scss" scoped>

.account_name_css:after {
  content: 'X';
  color: #ff4949;
}

.hong-xing {
  ::v-deep.el-form-item__label:before {
    content: "*";
    color: #F56C6C;
    margin-right: 4px;
  }
}
</style>
